module.exports = __webpack_public_path__ + "static/img/1-7.881aa8ea.png";